import type { ExperimentConfig } from '../@types'

const config: ExperimentConfig[] = [
	{
		'activity-female-walking': {
			landing: {
				experiment: () => import('@/modules/Landing/instances/experiments/web_walking_female_indoor'),
			},
			// ?safe&mock-data&utm_source=FB&country=US&area=activity-female-walking&exp=web_walking_female_indoor~1
			funnel: {
				id: 'ob-walking-female-indoor',
				locale: ['en'],
			},
		},
	},
]

export default config
